// import CryptoJS from "crypto-js"
class encipherUtil {
  // 这种方法测试环境不行会报错
  // 加密
  encrypt(word) {
    let encJSON = CryptoJS.AES.encrypt(JSON.stringify(word),'cncec')
    return CryptoJS.enc.Base64.stringify(CryptoJS.enc.Utf8.parse(encJSON))
  }
  // aes解密
  decrypt(word) {
    if(!word || !word.toString)return word;
    let dec = CryptoJS.AES.decrypt(CryptoJS.enc.Base64.parse(word).toString(CryptoJS.enc.Utf8),'cncec')
    return JSON.parse(dec.toString(CryptoJS.enc.Utf8))
  }

  // encrypt(word) {
  //   let encrypted = btoa(encodeURIComponent(word))
  //   return encrypted;
  // }
  //
  // decrypt(word) {
  //   if (!word || !word.toString) return word;
  //   try{
  //     let dec = decodeURIComponent(atob(word));
  //     return dec;
  //   }
  //   catch(e){
  //     console.error(e)
  //     return word;
  //   }
  // }

  setSessionStorageAES(key, params) {
    let result = this.encrypt(params)
    window.sessionStorage.setItem(key, result)
  }

  getSessionStorageAES(key) {
    let params = window.sessionStorage.getItem(key);
    if(params){
      try{
        return this.decrypt(params)
      }
      catch(e){
        console.error(e)
        window.sessionStorage.removeItem(key)
        return null;
      }
    } else{
      return params
    }
  }

  setLocalStorageAES(key, params) {
    let result = this.encrypt(params)
    window.localStorage.setItem(key, result)
  }

  getLocalStorageAES(key) {
    let params = window.localStorage.getItem(key);
    if(params){
      try{
        return this.decrypt(params)
      }
      catch(e){
        console.error(e)
        window.localStorage.removeItem(key)
        return null;
      }
    } else{
      return params
    }
  }
}

export default encipherUtil
